// @flow


const redirectHandler = (data: { url: string, }, context: { history: Object }) => {
    context.history.push(data.url);
};


export default { async: false, func: redirectHandler };
